import React from 'react';

// router importing
import Router from './routers/_index';

function App() {
  return (
    <div className="
      w-screen h-screen bg-slate-100
    ">
      <Router />
    </div>
  );
}

export default App;
